import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Sortable from 'sortablejs';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { pick } from 'lodash';

import EmptyList from './EmptyList';
import ServiceListItem from './serviceListItem';
import withLoadingList from '../../../common/hoc/withLoaingList';
import { canUserModifyServices } from '../../../common/helpers/users';
import { isBrandViewActive } from '../../../auth/selectors';

const renderServiceItem = service => <ServiceListItem service={service} key={service.id} />;

class ServicesList extends Component {
  constructor(props) {
    super(props);
    this.sortableInstance = null;
    this.isDragging = false;
    this.dragTimeout = null;
  }

  componentDidMount() {
    this.setupSortable();
  }

  onStart = () => {
    this.isDragging = true;
    clearTimeout(this.dragTimeout);
  }

  onEnd = () => {
    this.isDragging = false;
  }

  onSort = (e) => {
    const { services, onSortChange } = this.props;
    const currentOrder = services.map(service => pick(service, ['id', 'order']));
    this.arrayMove(services, e.oldIndex, e.newIndex);
    this.dragTimeout = setTimeout(() => {
      if (this.isDragging) return;
      onSortChange(currentOrder, e.oldIndex, e.newIndex);
    }, 600);
  }

  setupSortable() {
    this.sortableInstance = Sortable.create(this.sortable, {
      group: '', // To drag elements from one list into another, both lists must have the same group value
      handle: '.sortable-handle', // Drag handle selector within list items
      forceFallback: true, // Ignore the HTML5 DnD behaviour and force the fallback to kick in
      draggable: '.c-table-card__row', // Specifies which items inside the element should be draggable
      onStart: this.onStart,
      onEnd: this.onEnd,
      onSort: this.onSort,
    });
  }

  arrayMove(arr, fromIndex, toIndex) {
    const element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
  }

  render() {
    const { services, permissions, isBrandUser } = this.props;
    const canUserSortServices = canUserModifyServices(permissions) && !isBrandUser;
    return (
      <div className="c-table-with-sticky-header u-position-relative">
        <div className="u-scrollable-visible">
          <div className="c-table-card c-table-new c-sticky-header u-no-shadow c-table-card--fixed">
            <div className="c-table-card__head">
              <div
                className="c-table-card__cell c-label u-1/10 u-1/16-large-and-up"
                display-if={canUserSortServices}
              >Sort</div>
              <div
                className={`c-table-card__cell c-label ${canUserSortServices ?
                  'u-2/10 u-3/16-large-and-up' :
                  'u-3/10 u-4/16-large-and-up'}`}
              >
                Service name
              </div>
              <div className="c-table-card__cell c-label u-1/10 u-2/16-large-and-up">Duration</div>
              <div className="c-table-card__cell c-label u-1/10 u-2/16-large-and-up">Price</div>
              <div className="c-table-card__cell c-label u-2/10 u-3/16-large-and-up">Tax</div>
              <div className="c-table-card__cell c-label u-2/10 u-3/16-large-and-up">Category</div>
              <div className="c-table-card__cell c-label u-1/10 u-2/16-large-and-up">Status</div>
            </div>
          </div>
          <div className="c-table-card c-table-new c-table-card--fixed u--mt--" ref={(c) => { this.sortable = c; }}>
            {services.map(renderServiceItem)}
          </div>
        </div>
      </div>
    );
  }
}

ServicesList.propTypes = {
  services: PropTypes.array,
  onSortChange: PropTypes.func.isRequired,
  permissions: PropTypes.object.isRequired,
  isBrandUser: PropTypes.bool.isRequired,
};

ServicesList.defaultProps = {
  services: [],
};

const mapStateToProps = state => ({
  permissions: state.auth.permissions,
  isBrandUser: isBrandViewActive(state),
});

export default compose(
  connect(mapStateToProps),
  withLoadingList(
    props => props.services,
    EmptyList,
  )
)(ServicesList);
